import { Box, Chip, Typography } from "@mui/material";
import useColors from "api/hooks/useColors";
import CustomTooltip from "components/CustomTooltip";
import StyledDataGrid from "components/StyledDataGrid";
import SearchInput from "components/filters/SearchInput";
import { useState } from "react";

const SkippedDetectorsTableWidget = ({ skippedDetectors, isLoading }) => {
  const colors = useColors();
  const [appliedFilters, setAppliedFilters] = useState({
    searchString: "",
  });

  const filteredDetectors = (() => {
    if (!skippedDetectors) return [];
    if (!appliedFilters.searchString) return skippedDetectors;

    const search = appliedFilters.searchString.toLowerCase();
    return skippedDetectors.filter(
      (item) =>
        item.id?.toString().toLowerCase().includes(search) ||
        item.title?.toLowerCase().includes(search) ||
        item.customers?.some((c) =>
          c.customer_id?.toLowerCase().includes(search)
        )
    );
  })();

  const columns = [
    {
      field: "id",
      headerName: "Detector ID",
      flex: 0.5,
    },
    {
      field: "title",
      headerName: "Title",
      flex: 1.5,
      renderCell: (params) => {
        return (
          params.value || (
            <Typography color={colors.text_secondary}>-</Typography>
          )
        );
      },
    },
    {
      field: "level",
      headerName: "Skip Level",
      flex: 0.6,
      renderCell: (params) => {
        return (
          <Chip
            label={params.value}
            size="small"
            sx={{
              backgroundColor: colors.info_main,
              color: colors.common_white,
            }}
          />
        );
      },
    },
    {
      field: "customer_count",
      headerName: "Customers",
      flex: 0.4,
    },
    {
      field: "customers",
      headerName: "Customer IDs",
      flex: 2,
      renderCell: (params) => {
        const customerList = params.value || [];
        const displayCustomers = customerList
          .slice(0, 5)
          .map((c) => c.customer_id);
        const remaining = customerList.length - 5;

        return (
          <Box>
            <Typography variant="caption">
              {displayCustomers.join(", ")}
              {remaining > 0 && (
                <CustomTooltip
                  title={customerList
                    .slice(5)
                    .map((c) => c.customer_id)
                    .join(", ")}
                >
                  <span style={{ color: colors.text_secondary }}>
                    {" "}
                    +{remaining} more
                  </span>
                </CustomTooltip>
              )}
            </Typography>
          </Box>
        );
      },
    },
  ];

  return (
    <Box
      sx={{ height: "100%", display: "flex", flexDirection: "column", gap: 2 }}
    >
      <Box sx={{ padding: "8px 0" }}>
        <SearchInput
          fieldName="searchString"
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
          placeholder="Search detectors, customers..."
        />
      </Box>
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <StyledDataGrid
          rows={filteredDetectors.map((item, idx) => ({
            id: idx,
            ...item,
          }))}
          columns={columns}
          loading={isLoading}
          disableRowSelectionOnClick
          pageSizeOptionsOverride={[10, 25, 50]}
          autoHeight={false}
          boxSXProps={{ height: "100%" }}
        />
      </Box>
    </Box>
  );
};

export default SkippedDetectorsTableWidget;
